import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_NPDAY_80: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_NPDAY_80,
  },
  {
    pageId: PageId.CHAT_UPSELL_NPDAY_80,
  },
  {
    pageId: PageId.UPSELL_NPDAY_80,
  },
  {
    pageId: PageId.DOWNLOAD_NPDAY_80,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
